import React from 'react';
import './incomemaxMessenger.style.css'
const IncomeMaxMessengerComponent = () => {

    return(
        <div className="income-max-messenger-body">
            <h3 className="subheader" style={{color: "#fff"}}> 
            Ready to begin?
            </h3>
            <p>
            This three-step process tells you exactly what to upload, based on your circumstances, You may need to go away and find the relevant documents before coming back to upload them.
            </p>
        </div>
    )
}

export default IncomeMaxMessengerComponent;